"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Users = void 0;
var typeorm_1 = require("typeorm");
var student_personal_details_1 = require("../enums/student_personal_details");
var Users = /** @class */function () {
  function Users() {}
  __decorate([(0, typeorm_1.PrimaryGeneratedColumn)("uuid"), __metadata("design:type", String)], Users.prototype, "id", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], Users.prototype, "firebaseId", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], Users.prototype, "firstName", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Users.prototype, "lastName", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], Users.prototype, "email", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], Users.prototype, "phoneNumber", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: 91
  }), __metadata("design:type", Number)], Users.prototype, "countrycode", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: false
  }), __metadata("design:type", Boolean)], Users.prototype, "isPhoneVerified", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: false
  }), __metadata("design:type", Boolean)], Users.prototype, "isEmailVerified", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: new Date()
  }), __metadata("design:type", String)], Users.prototype, "lastlogin", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], Users.prototype, "imageUrl", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true,
    default: null
  }), __metadata("design:type", String)], Users.prototype, "referredBy", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: [],
    type: "jsonb"
  }), __metadata("design:type", Array)], Users.prototype, "joinedLiveClassDates", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false,
    default: [],
    type: "jsonb"
  }), __metadata("design:type", Array)], Users.prototype, "joinedDemoSessionDates", void 0);
  __decorate([(0, typeorm_1.Column)("text", {
    array: true,
    nullable: true,
    default: [student_personal_details_1.RoleEnum.PrecourseUser]
  }), __metadata("design:type", Array)], Users.prototype, "roles", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Users.prototype, "utm_source", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Users.prototype, "utm_campaign", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Users.prototype, "utm_content", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Users.prototype, "utm_medium", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", Boolean)], Users.prototype, "callbackRequest", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Users.prototype, "callbackRequestTime", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: null
  }), __metadata("design:type", String)], Users.prototype, "firstLoginAfterPrecourseStart", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)(), __metadata("design:type", Date)], Users.prototype, "created_at", void 0);
  __decorate([(0, typeorm_1.UpdateDateColumn)(), __metadata("design:type", Date)], Users.prototype, "updated_at", void 0);
  __decorate([(0, typeorm_1.Column)({
    type: "jsonb",
    nullable: true,
    default: []
  }), __metadata("design:type", Array)], Users.prototype, "eligibility", void 0);
  Users = __decorate([(0, typeorm_1.Entity)()], Users);
  return Users;
}();
exports.Users = Users;